import { Injectable, inject, NgZone } from '@angular/core';
import { ToastService } from './toast.service';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({ providedIn: 'root' })
export class UnhandledRejectionService {
  private toastService = inject(ToastService);
  private transloco = inject(TranslocoService);
  private zone = inject(NgZone);

  constructor() {
    this.installListener();
  }

  private installListener() {
    window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
      // Sentry's global handlers integration automatically captures the rejection.
      // We only show a user‑friendly toast.
      this.zone.run(() => {
        const msg = this.toastService.mapBackendError(event.reason);
        this.toastService.show(msg, 'error');
      });
    });
  }
}
